module.exports = __webpack_public_path__ + "img/icon-change-phone.bb0e75cf.jpg";